import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, MailIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { NAV, PRACTICE } from '../../content/site';
import { Wordmark } from './Wordmark';
import { LanguageToggle } from './LanguageToggle';
export function Navbar() {
  const {
    language
  } = useLanguage();
  const t = NAV[language];
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled ? 'border-b border-espresso/10 bg-cream/90 py-3 backdrop-blur-xl' : 'border-b border-transparent bg-transparent py-5'}`} data-id="element-156" data-mp="332qg2k5i5oy5">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-5 sm:px-8 lg:px-10" data-id="element-157" data-mp="32o2tbbdqbk4d">
        <Wordmark data-id="element-158" data-mp="2xq0zpwiog2en" />

        <nav className="hidden items-center gap-8 lg:flex" data-id="element-159" data-mp="2xog74cfxatjf">
          {t.links.map(link => <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => `text-[11px] font-semibold uppercase tracking-[0.16em] transition-colors ${isActive ? 'text-espresso' : 'text-espresso/55 hover:text-espresso'}`} data-id="element-160" data-mp="2srg6ih1ueizp">
              {link.label}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-161" data-mp="2513sqpjx1s17">
          <LanguageToggle data-id="element-162" data-mp="251lx69gqfck7" />
          <a href={`mailto:${PRACTICE.email}`} aria-label={PRACTICE.email} className="text-espresso/50 transition-colors hover:text-espresso" data-id="element-163" data-mp="1vd7y5rqvxxjd">
            <MailIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-164" data-mp="209ydudys2r49" />
          </a>
          <Link to="/contact" className="rounded-full border border-espresso/25 px-5 py-2.5 text-[10px] font-semibold uppercase tracking-[0.16em] text-espresso transition-all hover:bg-espresso hover:text-cream" data-id="element-165" data-mp="1me4heuf6xu81">
            {t.cta}
          </Link>
        </div>

        <div className="flex items-center gap-3 lg:hidden" data-id="element-166" data-mp="2j2am1hc44mmb">
          <LanguageToggle data-id="element-167" data-mp="25c795gz4i59j" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? t.close : t.menu} aria-expanded={open} className="p-1.5 text-espresso" data-id="element-168" data-mp="25amapg9ou26e">
            {open ? <XIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-169" data-mp="31t1vsk00if18" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-170" data-mp="31v4vxwuvpojo" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-171" data-mp="lfhwlf8fniiu">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.4,
        ease: [0.33, 1, 0.68, 1]
      }} className="overflow-hidden border-t border-espresso/10 bg-cream lg:hidden" data-id="element-172" data-mp="leozl5za07dw">
            <div className="mx-auto flex w-full max-w-6xl flex-col gap-1 px-5 py-6 sm:px-8" data-id="element-173" data-mp="2gdrghk0i8wg">
              {t.links.map(link => <NavLink key={link.to} to={link.to} className="border-b border-espresso/10 py-3.5 text-[12px] font-semibold uppercase tracking-[0.16em] text-espresso/80" data-id="element-174" data-mp="hdwo062xlqeg">
                  {link.label}
                </NavLink>)}
              <Link to="/contact" className="mt-5 rounded-full bg-espresso px-6 py-3.5 text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-cream" data-id="element-175" data-mp="1nsxbdndw509f">
                {t.cta}
              </Link>
              <a href={`mailto:${PRACTICE.email}`} className="mt-4 text-center text-[11px] font-light text-espresso/55" data-id="element-176" data-mp="6djhgv3gcgqk">
                {PRACTICE.email}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}